import { validationLength } from "../components/actions/validations";

const textMax = validationLength.departmentName;

const alphanumericRule = (max: number) =>
  `Max ${max} characters; letters, numbers and spaces only; no special characters.`;

/** Default (non-error) helper text under Reserve Service Charge fields. */
export const reserveServiceChargeFieldHelperText = {
  serviceCharge: `${alphanumericRule(textMax)} Mandatory.`,
  value: `${alphanumericRule(textMax)} Optional.`,
} as const;

/** Error helper text (shown in red when field validation fails). */
export const reserveServiceChargeFieldErrors = {
  required: "This field is required.",
  serviceCharge: alphanumericRule(textMax),
  value: alphanumericRule(textMax),
} as const;
